<template>
  <van-popup v-model:show="showIdentity" round position="bottom" safe-area-inset-bottom>
    <van-picker title="请选择客户身份" ref="picker" :columns="identityList" @confirm="confirmIdentity" @cancel="cancel" />
  </van-popup>
</template>

<script>
import { reactive, toRefs, watch, nextTick, ref } from 'vue'
import { onBeforeRouteLeave } from 'vue-router'
export default {
  emits: ['getIdentity'],
  props: ['showNum', 'identity'],
  setup(props, { emit }) {
    let { showNum, identity } = toRefs(props)
    const state = reactive({
      showIdentity: false,
      showNum,
      identityList: ['车主', '用车人', '其他']
    })

    onBeforeRouteLeave(() => {
      state.showIdentity = false
    })

    const picker = ref(null)

    const confirmIdentity = (val, i) => {
      state.showIdentity = false
      emit('getIdentity', { key: i + 1, value: val })
    }

    const cancel = () => (state.showIdentity = false)

    watch(
      () => state.showNum,
      () => {
        state.showIdentity = true
        let { key, value } = identity.value
        if (key) {
          // 反选
          nextTick(() => {
            picker.value.setIndexes([key - 1])
            picker.value.setValues([value])
          })
        }
      }
    )

    return {
      ...toRefs(state),
      picker,
      confirmIdentity,
      cancel
    }
  }
}
</script>
